import { render } from "./DownloadForm.vue?vue&type=template&id=46f4045f&scoped=true&ts=true"
import script from "./DownloadForm.ts?vue&type=script&lang=ts"
export * from "./DownloadForm.ts?vue&type=script&lang=ts"

import "./DownloadForm.scss?vue&type=style&index=0&id=46f4045f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f4045f"]])

export default __exports__